import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary/10 text-primary border border-primary/20",
        secondary:
          "bg-secondary text-secondary-foreground border border-border",
        destructive:
          "bg-status-error text-status-error-foreground border border-status-error",
        outline: 
          "text-foreground border border-border",
        success:
          "bg-status-success text-status-success-foreground border border-status-success",
        warning:
          "bg-status-warning text-status-warning-foreground border border-status-warning",
        info:
          "bg-status-info text-status-info-foreground border border-status-info",
        // Minimal variants - just colored text with subtle background
        "success-subtle":
          "bg-transparent text-status-success-foreground",
        "warning-subtle":
          "bg-transparent text-status-warning-foreground",
        "error-subtle":
          "bg-transparent text-status-error-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
